import React from "react";

class Metrica extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			admin: (window.localStorage.getItem("admin") === 'Y')
		};
	}

	componentDidMount() {
		if (this.state.admin || process.env.REACT_APP_OMIT_METRICS === "Y")
			return;
		try {
			this.leadback()
		} catch (e) {
			console.warn(e);
		}
		try {
			this.ymetrics()
		} catch (e) {
			console.warn(e);
		}
		/*try {
			this.victorycorp()
		} catch (e) {
			console.warn(e);
		}*/
		setTimeout(() => {
			try {
				this.mangooffice()
			} catch (e) {
				console.warn(e);
			}
		}, 1000);
	}

	/*victorycorp() {
		
		(function (d, w) {
			var n = d.getElementsByTagName("script")[0],
				s = d.createElement("script");
			s.type = "text/javascript";
			s.async = true;
			s.src = "https://victorycorp.ru/index.php?ref=" + d.referrer + "&page=" + encodeURIComponent(w.location.href);
			n.parentNode.insertBefore(s, n);
			console.log('victorycorp', s);
		})(document, window);
	}*/

	leadback() {
		window._emv = window._emv || [];
		window._emv['campaign'] = 'b0f169f34a2db30564d287d6';

		(function () {
			var em = document.createElement('script');
			em.type = 'text/javascript';
			em.async = true;
			em.src = ('https:' == document.location.protocol ? 'https://' : 'http://') + 'leadback.ru/js/leadback.js';
			var s = document.getElementsByTagName('script')[0];
			s.parentNode.insertBefore(em, s);
		})();
	}

	ymetrics() {
		(function (m, e, t, r, i, k, a) {
			m[i] = m[i] || function () {
				(m[i].a = m[i].a || []).push(arguments)
			};
			m[i].l = 1 * new Date();
			k = e.createElement(t);
			a = e.getElementsByTagName(t)[0];
			k.async = 1;
			k.src = r;
			a.parentNode.insertBefore(k, a);
		})
			(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");

		window.ym(51042350, "init", {
			clickmap: true,
			trackLinks: true,
			accurateTrackBounce: true,
			webvisor: true
		});
	}

	mangooffice() {
		// Ensure loader is executed
		(function (w, d, u, i, o, s, p) {
			if (d.getElementById(i)) {
				return;
			}
			w['MangoObject'] = o;
			w[o] = w[o] || function () {
				(w[o].q = w[o].q || []).push(arguments);
			};
			w[o].u = u;
			w[o].t = 1 * new Date();
			s = d.createElement('script');
			s.async = 1;
			s.id = i;
			s.src = u;
			p = d.getElementsByTagName('script')[0] || d.getElementsByTagName('head')[0];
			p.parentNode.insertBefore(s, p);
		}(window, document, 'https://widgets.mango-office.ru/widgets/mango.js', 'mango-js', 'mgo'));

		const mangoConfig = {
			calltracking: {
				id: 30596,
				elements: [
					{ numberText: "78312621085" },
					{ numberText: "+7 (831) 262-10-85" },
					{ numberText: "+78312621085" },
					{ numberText: "8 (831) 262-10-85" },
					{ numberText: "7 (831) 262-10-85" },
					{ numberText: "+7 831 262-10-85" },
					{ numberText: "+7 (831) 262 10 85" },
					{ numberText: "+7 (831) 262-1085" },
					{ selector: ".mgo-number-30596" },
					{ selector: ".mgo-number" },
					{ selector: ".mango-phone" },
					{ selector: ".ts_dheader__phone_number" },
					{ selector: ".ts_dheader__phone_group" },
					{ selector: ".ts_nheader__phone_number" },
					{ selector: ".ts_nheader__phone_group" },
					{ selector: ".ts_mobility_hContacts__phone" },
					{ selector: ".footer__phone" },
					{ selector: ".HeaderPhone" },
					{ selector: ".nav__phone" },
					{ selector: ".header__phone" }
				]
			}
		};

		const defaultPhoneClean = "78312621085";

		const syncSubstitutedNumbers = () => {
			if (typeof window.mgo === 'function') {
				try {
					window.mgo(mangoConfig);
				} catch (e) {
					console.warn('mgo calltracking error', e);
				}
			}

			// Check if any element with .mgo-number-30596 or .mango-phone has been substituted by Mango
			try {
				let savedPhone = window.__mgoPhone || null;
				if (!savedPhone && typeof sessionStorage !== 'undefined') {
					const cached = sessionStorage.getItem('__mgo_saved_phone');
					if (cached) {
						savedPhone = JSON.parse(cached);
						window.__mgoPhone = savedPhone;
					}
				}

				const phoneElements = document.querySelectorAll(
					'.mgo-number-30596, .mgo-number, .mango-phone, .ts_dheader__phone_number, .ts_nheader__phone_number, .ts_mobility_hContacts__phone'
				);

				phoneElements.forEach(el => {
					const text = el.textContent ? el.textContent.trim() : '';
					const cleanDigits = text.replace(/\D/g, '');
					// If Mango has already substituted the text to a different phone number, capture it
					if (cleanDigits.length >= 10 && cleanDigits !== defaultPhoneClean && cleanDigits !== '78312621085' && cleanDigits !== '88312621085') {
						savedPhone = {
							nice: text,
							machine: '+' + cleanDigits
						};
						window.__mgoPhone = savedPhone;
						if (typeof sessionStorage !== 'undefined') {
							sessionStorage.setItem('__mgo_saved_phone', JSON.stringify(savedPhone));
						}
					}
				});

				// If we have a substituted phone, apply it across all matching elements and their parent <a> links
				if (savedPhone && savedPhone.nice) {
					phoneElements.forEach(el => {
						if (el.textContent && el.textContent.trim() !== savedPhone.nice) {
							// If element is a container with nested elements, update the text node or inner span
							const innerSpan = el.querySelector('span');
							if (innerSpan) {
								innerSpan.textContent = savedPhone.nice;
							} else if (el.children.length === 0) {
								el.textContent = savedPhone.nice;
							}
						}
						// If element or its closest ancestor is an <a> tag, update tel: href
						const anchor = el.tagName === 'A' ? el : el.closest('a');
						if (anchor && anchor.href && anchor.href.startsWith('tel:')) {
							anchor.href = 'tel:' + savedPhone.machine;
						}
					});
				}
			} catch (e) {
				console.warn('Mango phone sync error', e);
			}
		};

		window.refreshMangoCalltracking = syncSubstitutedNumbers;
		syncSubstitutedNumbers();

		// DOM observer for continuous phone substitution in React SPA
		if (typeof MutationObserver !== 'undefined' && !this._mangoObserver) {
			let debounceTimer = null;
			this._mangoObserver = new MutationObserver(() => {
				if (debounceTimer) {
					clearTimeout(debounceTimer);
				}
				debounceTimer = setTimeout(() => {
					syncSubstitutedNumbers();
				}, 200);
			});
			this._mangoObserver.observe(document.body, {
				childList: true,
				subtree: true
			});
		}
	}

	componentWillUnmount() {
		if (this._mangoObserver) {
			this._mangoObserver.disconnect();
			this._mangoObserver = null;
		}
	}

	static reachGoal(name) {
		try {
			console.log('reachGoal', name);
			window.ym(51042350, 'reachGoal', name);
		} catch (e) {
			console.log("RG: " + name);
		}
	}

	render() {
		if (this.state.admin) {
			return (
				<noscript>
					<div>
						<img
							src="https://mc.yandex.ru/watch/51042350"
							style="position:absolute; left:-9999px;"
							alt=""
						/>
					</div>
				</noscript>
			);
		}
		return <div className="m3tr1x" />;
	}
}

export default Metrica;
